import React from "react"

import { ContentTag } from "scrivito"

import { ProjectTeamInvitationList } from "features/project-team/ui/project-team-invitation-list/ProjectTeamInvitationList"

import { ProjectTeamInvitationListPageProps } from "./ProjectTeamInvitationListPage"
import "./styles/_project-team-invitation-list-page.scss"

interface ProjectTeamInvitationListPageViewModel
  extends ProjectTeamInvitationListPageProps {}

export const ProjectTeamInvitationListPageView = React.memo(
  ({ page = null, ...props }: ProjectTeamInvitationListPageViewModel) => {
    return (
      <div className="page project-team-invitation-list-page">
        <ContentTag attribute="body" content={page} />
        <div className="project-team-invitation-list-page__content">
          <ProjectTeamInvitationList {...props} />
        </div>
      </div>
    )
  }
)
